import Chat from "../../../../assets/Chat";
import Clients from "../../../../assets/Clients";
import ImportClient from "../../../../assets/ImportClient";
import Dashboard from "../../../../assets/Dashboard";
import Pipeline from "../../../../assets/Pipeline";
import Files from "../../../../assets/Files";
import Team from "../../../../assets/Team";
import Templates from "../../../../assets/Templates";
import Disc from "../../../../assets/Disc";
import Setting from "../../../../assets/Setting";
import Reports from "../../../../assets/Reports";
import Payments from "../../../../assets/Payments";
import Restore from "../../../../assets/Restore";
import ActivityIcon from "../../../../assets/ActivityIcon";
import Document from "../../../../assets/Document";
import PayrollIcon from "../../../../assets/PayrollIcon";

const sidebarData = [
  {
    title: "Dashboard",
    icon: <Dashboard />,
    url: "/dashboard",
    activeUrl: ["/dashboard", "/"],
  },
  {
    title: "Services",
    icon: <Files />,
    url: "/services",
    activeUrl: ["/services", "/file"],
  },
  {
    title: "Clients",
    icon: <Clients />,
    url: "/clients",
    activeUrl: ["/clients", "/client_details"],
  },
  {
    title: "Payroll",
    icon: <PayrollIcon />,
    url: "/payroll",
    activeUrl: ["/payroll", "/payroll_history", "/view_payroll"],
  },
  {
    title: "Documents",
    icon: <Document />,
    url: "/documents",
    activeUrl: ["/documents", "/document"],
  },
  {
    title: "Payments",
    icon: <Payments />,
    url: "/payments_report",
    activeUrl: ["/payments_report"],
  },
  {
    title: "Chat",
    icon: <Chat />,
    url: "/communication",
    activeUrl: ["/communication"],
  },
  {
    title: "Team",
    icon: <Team />,
    url: "/team",
    activeUrl: ["/team"],
  },
  // {
  //   title: "Import Client",
  //   icon: <ImportClient />,
  //   url: "/import_client",
  //   activeUrl: ["/import_client"],
  // },
  {
    title: "Service Flow",
    icon: <Pipeline />,
    url: "/service_flow",
    activeUrl: ["/service_flow", "/task", "/task_detail"],
  },
  {
    title: "Activity",
    icon: <ActivityIcon />,
    url: "/activity",
    activeUrl: ["/activity"],
  },

  {
    title: "Archive",
    icon: <Restore />,
    activeUrl: ["/restore"],
    children: [
      {
        title: "Clients",
        icon: <Disc />,
        url: "/restore_clients",
        activeUrl: ["/restore_clients"],
      },
      {
        title: "Files",
        icon: <Disc />,
        url: "/restore_files",
        activeUrl: ["/restore_files", "/restore_file"],
      },
    ],
  },

  {
    title: "Templates",
    icon: <Templates className="size-6" />,
    activeUrl: ["/service_templates", "/invoice_templates"],
    children: [
      {
        title: "Services",
        icon: <Disc />,
        url: "/service_templates",
        activeUrl: ["/service_templates","/service_template", "/service"],
      },
      {
        title: "Invoices",
        icon: <Disc />,
        url: "/invoice_templates",
        activeUrl: ["/invoice_templates"],
      },
    ],
  },
  {
    title: "Reports",
    icon: <Reports />,
    activeUrl: ["/report/files"],
    children: [
      {
        title: "Services",
        icon: <Disc />,
        url: "/files_report",
        activeUrl: ["/files_report"],
      },
      {
        title: "Invoice",
        icon: <Disc />,
        url: "/invoice_report",
        activeUrl: ["/invoice_report"],
      },
      {
        title: "Signature",
        icon: <Disc />,
        url: "/signature_report",
        activeUrl: ["/signature_report"],
      },
    ],
  },
  {
    title: "Settings",
    icon: <Setting />,
    activeUrl: ["/tags"],
    children: [
      {
        title: "Tags",
        icon: <Disc />,
        url: "/tags",
        activeUrl: ["/tags"],
      },
      {
        title: "Banners",
        icon: <Disc />,
        url: "/banners",
        activeUrl: ["/banners"],
      },
      {
        title: "Site Settings",
        icon: <Disc />,
        url: "/settings",
        activeUrl: ["/settings"],
      },
    ],
  },
];

export default sidebarData;
